import {ServiceOrderStatus} from "./ServiceOrderStatus";

export const ServiceOrderStatusColors: Record<ServiceOrderStatus, "primary" | "secondary" | "info" | "warning" | "error" | "success" | "default"> = {
  [ServiceOrderStatus.IN_PROGRESS]: "primary",
  [ServiceOrderStatus.DEFINE_WORK_SCOPE]: "info",
  [ServiceOrderStatus.VALIDATE_WORK_SCOPE]: "warning",
  [ServiceOrderStatus.FIX_WORK_SCOPE]: "error",
  [ServiceOrderStatus.SENT]: "secondary",
  [ServiceOrderStatus.CONFIRM]: "info",
  [ServiceOrderStatus.COMPLETED]: "warning",
  [ServiceOrderStatus.TO_FIX]: "error",
  [ServiceOrderStatus.CLOSED]: "success",
  [ServiceOrderStatus.UNDER_EVALUATION]: "default",
};
